export default __webpack_public_path__ + "static/media/pic10.7de0e001.jpg";